import PerformanceSpreadsheetReport from 'presentation/app/modules/PerformanceSpreadsheetReport/pages';
import React from 'react';

export const MakePerformanceSpreadsheetReport: React.FC = () => {
  return <PerformanceSpreadsheetReport />;
};
